import {
  CHANGE_COMPANY_SEARCH_KEYWORD,
  FAILURE_CREATE_COMPANY,
  FAILURE_FETCH_COMPANY,
  FAILURE_SEARCH_COMPANIES,
  FAILURE_UPDATE_COMPANY,
  FILTER_COMPANIES,
  REQUEST_CREATE_COMPANY,
  REQUEST_FETCH_COMPANY,
  REQUEST_SEARCH_COMPANIES,
  REQUEST_UPDATE_COMPANY,
  RESET_COMPANY,
  SET_SEARCH_COMPANY_DEMO_PARAMS,
  SET_SEARCH_COMPANY_STATUS,
  SUCCESS_CREATE_COMPANY,
  SUCCESS_FETCH_COMPANY,
  SUCCESS_SEARCH_COMPANIES,
  SUCCESS_UPDATE_COMPANY,
} from 'actions/actionTypes';
import { CompanyUpdateParamsTypes } from 'types/backend/company';
import { CompanyTypes } from 'types/backyard/company';

export const requestFetchCompany = (id?: string | null) => ({
  type: REQUEST_FETCH_COMPANY,
  id,
});

export const successFetchCompany = (payload: CompanyTypes) => ({
  type: SUCCESS_FETCH_COMPANY,
  payload,
});

export const failureFetchCompany = () => ({
  type: FAILURE_FETCH_COMPANY,
});

export const requestSearchCompanies = (searchWord?: string, pageNumber?: number) => ({
  type: REQUEST_SEARCH_COMPANIES,
  searchWord,
  pageNumber,
});

export const successSearchCompanies = (
  payload: CompanyTypes[],
  size: number,
  pageNumber?: number,
) => ({
  type: SUCCESS_SEARCH_COMPANIES,
  payload,
  size,
  pageNumber,
});

export const failureSearchCompanies = () => ({
  type: FAILURE_SEARCH_COMPANIES,
});

export const setSearchCompanyDemoParams = (demoParam?: boolean) => ({
  type: SET_SEARCH_COMPANY_DEMO_PARAMS,
  demoParam,
});

export const setSearchCompanyStatus = (status?: 'active' | 'inactive') => ({
  type: SET_SEARCH_COMPANY_STATUS,
  status,
});

export const resetCompany = () => ({
  type: RESET_COMPANY,
});

export const changeCompanySearchKeyword = (keyword: string) => ({
  type: CHANGE_COMPANY_SEARCH_KEYWORD,
  keyword,
});

export const filterCompanies = (filteredCompanies: CompanyTypes[]) => ({
  type: FILTER_COMPANIES,
  filteredCompanies,
});

export const requestCreateCompany = (name: string, demoParam?: boolean) => ({
  type: REQUEST_CREATE_COMPANY,
  name,
  demoParam,
});

export const successCreateCompany = (payload: CompanyTypes) => ({
  type: SUCCESS_CREATE_COMPANY,
  payload,
});

export const failureCreateCompany = () => ({
  type: FAILURE_CREATE_COMPANY,
});

export const requestUpdateCompany = (params: CompanyUpdateParamsTypes) => ({
  type: REQUEST_UPDATE_COMPANY,
  params,
});

export const successUpdateCompany = (payload: CompanyTypes) => ({
  type: SUCCESS_UPDATE_COMPANY,
  payload,
});

export const failureUpdateCompany = () => ({
  type: FAILURE_UPDATE_COMPANY,
});
